import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/repo/global-music-ssr/src/component/Firebase.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/style/style.css");
